import React from "react";
import { motion } from "framer-motion";

import * as headingAnimationStyles from "./headingAnimation.module.scss";

export default function HeadingAnimation({ context, index, onClick }) {
  return (
    <h5 className={headingAnimationStyles.headingAnimation}>
      <motion.span
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: -10 }}
        transition={{
          delay: index * 0.1,
          type: "tween",
          duration: 0.7,
        }}
        className={headingAnimationStyles.headingAnimation__child}
        onClick={() => onClick && onClick()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClick();
          }
        }}
        aria-label="Visit Modal"
        role="button"
        tabIndex="0"
      >
        {context}
      </motion.span>
    </h5>
  );
}
